import {USER_SORT_ALPHA, USER_SORT_GENDER} from '../constants/users';

const DEFAULT_SETTINGS = {
    bold: false,
    italic: false,
    color: "#000000",
    family: "Arial",
    size: 14,
    timestamps: true,
    sortby: USER_SORT_GENDER,
    pm_request_sound: false,
    pm_message_sound: false,
    new_pm_tip_sound: true,
    new_tip_sound: true,
};

class Settings {
    constructor() {
        this.storageKey = "chatsettings";

        this.read();
        if (typeof this.values === "undefined") this.values = DEFAULT_SETTINGS;
        else this.values = { ...DEFAULT_SETTINGS, ...this.values };
    }

    _supports_html5_storage() {
        try {
            return "localStorage" in window && window["localStorage"] !== null;
        } catch (e) {
            return false;
        }
    };

    read() {
        if (this._supports_html5_storage()) {
            var item = localStorage.getItem(this.storageKey);
            if (item) {
                this.values = JSON.parse(item);
            }
        }
    };

    write() {
        if (this._supports_html5_storage()) {
            localStorage.setItem(this.storageKey, JSON.stringify(this.values));
        }
    };

    get(name) {
        return this.values[name];
    };

    getAll() {
        return this.values;
    };

    set(name, value) {
        this.values[name] = value;
        this.write();
    };
}

export default Settings;



// WEBPACK FOOTER //
// ./src/settings/index.js